import { useMutation, useQueryClient } from '@tanstack/react-query';

interface SuggestCandidatesParams {
  jobPostId: number;
  candidateProfileIds: number[];
}

export default function useSuggestCandidates() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ jobPostId, candidateProfileIds }: SuggestCandidatesParams) => {
      const response = await fetch(
        `/agent/api/job_post_endpoints/${jobPostId}/bulk_job_post_insert.json`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token':
              document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
          },
          body: JSON.stringify({
            candidate_profile_ids: candidateProfileIds,
          }),
        }
      );

      if (!response.ok) {
        throw new Error('Failed to suggest candidates');
      }

      return response.json();
    },
    onSuccess: (_, { jobPostId }) => {
      // 提案候補者リストを再取得
      queryClient.invalidateQueries({ queryKey: ['suggestedCandidates', jobPostId] });
      // 求人詳細のカウンターも更新
      queryClient.invalidateQueries({ queryKey: ['providedJobPost', jobPostId] });
    },
  });
}
